/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, cap: NonNullable<unknown> }} Usage_Tab_Budget_UsedInputs */



/**
* | output |
* | --- |
* | "{used} of {cap} used this period" |
*
* @param {Usage_Tab_Budget_UsedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_budget_used = /** @type {((inputs: Usage_Tab_Budget_UsedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Budget_UsedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.used} von ${i?.cap} in diesem Zeitraum verbraucht`)
	return /** @type {LocalizedString} */ (`${i?.used} of ${i?.cap} used this period`)
});